// api.js
import axios from "axios";
import { AWS_LINK, DEV_LINK } from "../Static/static";


// Create an Axios instance
// DEV: http://localhost:3333/api/
// NOTE: current alb needs to route53 -> domain -> alb Alias ..

const LINK = process.env.NODE_ENV === "production" ? AWS_LINK : DEV_LINK;
const API = axios.create({
  withCredentials: true,
  baseURL: LINK + "/api", // Replace with your API base URL
  timeout: 90000,
  timeoutErrorMessage: "Request timed out. Please try again.",
});

API.interceptors.request.use(
  async (config) => {
    // Access token
    const stored_role = localStorage.getItem('role');
    if (stored_role) {
      const parse = JSON.parse(stored_role);
      const token = parse.token;
      config.headers['Authorization'] = 'Bearer ' + token; // Add your access token short duration
    }
    return config; // Return the modified config
  },
  (error) => {
    // Handle request errors
    return Promise.reject(error);
  }
);

// Add a response interceptor
API.interceptors.response.use(
  (response) => {
  if (response.headers) {
    const token = response.headers['x-access-token']
      if (token) {
        try {
          const storedRoleRaw = localStorage.getItem('role');
          if (storedRoleRaw) {
            const storedRole = JSON.parse(storedRoleRaw);
            storedRole.token = token;
            localStorage.setItem('role', JSON.stringify(storedRole));
          }
        } catch (error) {
          console.error('Unable to set new x-access-token', error);
        }
      }
  }
    return response; // Return response data
  },
  (error) => {
    if (error.response) {
      const { status } = error.response;
      if (status === 401) {
        console.error("401 Unauthorized: Token might have expired.");
        sessionStorage.clear(); // Added apr 7: should log user out
        localStorage.clear(); // Added apr 7: should remove all data
        return Promise.reject({ message: "Session expired. Please log in.", status });
      }
      if (status === 403) {
        return Promise.reject({isForbidden: true, message: 'forbidden'});
      }
      return Promise.reject(
        { message: error.response.data ? error.response.data : "An error occurred." }
      );
    } 
    else if (error.request) {
      console.error("Network Error: No response from server.");
      return Promise.reject({
        message: "Network error. Please check your connection.",
      });
    } 
    else {
      return Promise.reject({
        message: "Unexpected error occurred :)",
      });
    }
  }
);

export default API;

